 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		98: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~pages-admin-teams~pages-class-details-logged-in~pages-class-details-logged-out~pages-class-d~056cf466","1":"vendors~pages-class-details-logged-in~pages-class-details-logged-out~pages-classes~pages-classes-cla~8ed26321","2":"dllVendors","3":"tinymce","4":"vendors~pages-adminMarketingBanner~pages-home~pages-site~pages-visa~pages-visa-footer","5":"d3","6":"vendors~pages-class-details-logged-in~pages-class-details-logged-out~pages-site-gallery~pages-workshops-show","7":"vendors~pages-adminMarketingBanner~pages-home~pages-site","8":"pages-classes~pages-classes-class-collections~pages-site","9":"pages-embed-video~pages-site-join~pages-workshops-show","10":"pages-membership-welcome~pages-site-settings-referrals~pages-site-settings-teacher-referrals","11":"pages-classes-class-collections~pages-customLists-lists","12":"pages-embed-video~pages-site-join","13":"pages-site-settings-payment~pages-teams-checkout","14":"pages-adminMarketingBanner","15":"pages-class-details-logged-in","16":"pages-class-details-logged-out","17":"pages-class-details-reviews","18":"pages-classes","19":"pages-customLists","20":"pages-error","21":"pages-home","22":"pages-marketingPages","23":"pages-notifications","24":"pages-projects","25":"pages-redeem","26":"pages-search","27":"pages-site","28":"pages-teach","29":"pages-teacherStats","30":"pages-teaching","31":"pages-userProfile","32":"pages-visa","33":"pages-yourClasses","34":"vendors~pages-class-details-logged-out","35":"vendors~pages-classes","36":"vendors~pages-search","37":"vendors~pages-visa","38":"pages-admin-adjust-team-seats","39":"pages-admin-batch-delete-users","40":"pages-admin-coupons","41":"pages-admin-monthly-revenue","42":"pages-admin-teacher-payout","43":"pages-admin-teams","44":"pages-admin-trust-and-safety","45":"pages-admin-users-show","46":"pages-adminMarketingBanner-edit","47":"pages-checkout-item","48":"pages-class-details-logged-in-class-admin","49":"pages-classes-class-collections","50":"pages-classes-create","51":"pages-classes-video-lessons-table","52":"pages-common-footer","53":"pages-customLists-form","54":"pages-customLists-lists","55":"pages-customLists-show","56":"pages-embed-project","57":"pages-embed-video","58":"pages-giftCards-form","59":"pages-membership-cancel","60":"pages-membership-cancel-step-two","61":"pages-membership-paypal-cancel","62":"pages-membership-paypal-success","63":"pages-membership-perks","64":"pages-membership-react-checkout","65":"pages-membership-rejoin","66":"pages-membership-welcome","67":"pages-projects-edit","68":"pages-reviews-create","69":"pages-site-gallery","70":"pages-site-join","71":"pages-site-login","72":"pages-site-premium-landing","73":"pages-site-scholarships","74":"pages-site-settings-account","75":"pages-site-settings-language","76":"pages-site-settings-notifications","77":"pages-site-settings-payment","78":"pages-site-settings-react-account","79":"pages-site-settings-referrals","80":"pages-site-settings-teacher-referrals","81":"pages-site-settings-team-administration","82":"pages-teach-form","83":"pages-teams-activate","84":"pages-teams-checkout","85":"pages-teams-new","86":"pages-teams-signup","87":"pages-userProfile-discussionShow","88":"pages-userProfile-discussions","89":"pages-visa-check","90":"pages-visa-footer","91":"pages-visa-header","92":"pages-workshops-form","93":"pages-workshops-show","94":"pages-workshops-test-index","95":"vendors~pages-membership-react-checkout","96":"vendors~pages-projects-edit","97":"vendors~pages-visa-header"}[chunkId]||chunkId) + ".build." + {"0":"40ee9d2d904cf232b2ae","1":"dad4f4583b1fd4741b24","2":"649707e59ebd22b660e9","3":"d2ba23a68a6af05a9492","4":"1dc143a8caa40194031e","5":"1554af8e9822c9de9d93","6":"b366f4f0be7d6abed7af","7":"1772cba5582d8a243d81","8":"7f7333bf9be7d3e92a9c","9":"ee71983d00a409b3a8d6","10":"c2489544323357daeb0f","11":"3b72d7f4a984b2b28c5c","12":"60d8784c394f9f71eef6","13":"663f7952d3da5445896a","14":"69fe83acf026701a6079","15":"51f2e336bbcc27a63566","16":"2f2a0e320e2aa1f437a9","17":"84b6943b7f110f959c19","18":"c35aa7f3bcf6fbfd6d8e","19":"26220bf886bbbf9d7f06","20":"6440ca07bbea33377a9e","21":"550bc9ff603a7752a731","22":"d6f8d5244fc0fcf6aedf","23":"72ffc138374550744e2d","24":"cf76c1bcdeb20359194b","25":"1052a72955a1f97e61e8","26":"ad702d2a1b6d01e6e7aa","27":"a4034a441b4afbc859d8","28":"e0ed80f1bcacb324136a","29":"2e30f3cb56d48f185838","30":"46828d8e415a065f9bf8","31":"fdef0289b8250ff4fd48","32":"c09ac8914920f6b4645f","33":"7f154a1b31f7e77721e5","34":"2b47ffd0d961b3045872","35":"257ed9c045e747d794ea","36":"6e5190fb37833f361e8f","37":"8caafddcee4292cfc3bb","38":"83e7c74fe8c13280c7a5","39":"13733dd34a6dc2e5ea34","40":"9a78c3d0ba17a2c04f29","41":"3e40fe73d05cba1dcea3","42":"29f128a121d4d9d10237","43":"68b34d7841155e3d963a","44":"ccd9313e6859776cd21a","45":"c4702289dffca45ebe04","46":"f1ea50157f0ac61a0814","47":"4956a7f79f2ea693403f","48":"1312bc1ae717aee3fb4e","49":"bcb20a23fe386e4bc571","50":"7820d6bdcf6da28cf9ec","51":"8a1175fc3d9b87809b40","52":"d33e468436025eb600da","53":"e1fae9659dae91038b0b","54":"adb9365b56ba6a3af11d","55":"60493cabcab9c0776868","56":"8ea1d4da720475354ed2","57":"bc257736c0ede47b2a3e","58":"baebc8a22475e7d54cb1","59":"ab23197d6386232fa096","60":"eb62406340697352cfaf","61":"ec286de28fae9112b710","62":"db1c93256b7aa8471071","63":"0b53cd250ed832bd8bff","64":"e9db86b9c7a5c789b864","65":"33f0cb625425742ecfe8","66":"412c92836a4038def2a2","67":"8791c8d7e00c93bd7723","68":"0554a84e543f4b1fb2bf","69":"74403190880f37313301","70":"91f35fdefb69ce0cd9cb","71":"c88527f3e9ae4d783464","72":"af21f088f72843ee5b98","73":"5942147417cbd975e7bb","74":"1ce76ca176bd44498ce2","75":"f3147883d47792178e40","76":"a9c98912738a1d45601f","77":"5ab40f4da20e8198493e","78":"e036c82b6563e9add8a4","79":"a82b3694ff13c2a3664b","80":"c82d02e681c924d1958e","81":"4eaa7172632c2b6381c0","82":"69938bfe30c5709ba563","83":"6bb92679612e685b1923","84":"b3dc5cf07c332aa6f9ff","85":"4a2518883e09459570aa","86":"1ac131bc77b24cf3bc7e","87":"080e4c5b379c2890e234","88":"411be4d16fad845c5ebf","89":"7d37f802b18ee7c8a17d","90":"fbc8072027c088e1b265","91":"1a0bf4ad917d579b5d00","92":"6fe11a0adadd6d7e0630","93":"792739990fd62b43230a","94":"fa074947454d4828eb94","95":"94a2c44d294d79431620","96":"35e5b64ed30cd9880455","97":"888a5546bebb611ded67","99":"04bb586d0bed23a125f0","100":"1259ce7218e98c1b07d0","101":"183a4b415fdb9b36630c","102":"96868b89e8e4a5c45a4c","103":"4ce1601f2e903a5c7666","104":"6a71ada135a37c216ddd","105":"2aef306b41f58a0fa959","106":"ef8220228dfef6a5decb","107":"63e27139b65947d7533c"}[chunkId] + ".min.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://static.skillshare.com/build/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 770);
